exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-dialog__body[data-v-f4ec3ee4] {\r\n  padding: 10px 20px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/plus/agent/user/dialog/SubUser.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB","file":"SubUser.vue","sourcesContent":["\n.el-dialog__body[data-v-f4ec3ee4] {\r\n  padding: 10px 20px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4ec3ee4","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/plus/agent/user/dialog/SubUser.vue
// module id = hCYD
// module chunks = 0